import styles from './Dignities.module.scss'
import { motion } from "framer-motion"
import img_1 from '../../image/Dignities/cena.png'
import img_2 from '../../image/Dignities/ok.png'
import img_3 from '../../image/Dignities/time.png'
import img_4 from '../../image/Dignities/tool.png'
import img_5 from '../../image/Dignities/arm.png'
import img_6 from '../../image/Dignities/garantia.png'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Dignities = () => {

    return (
        <motion.section 
        className={styles.main}
        id='preimushchestva' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >  
        <div className={styles.container}>
        <motion.h2 className={styles.title} variants={titleAnimation}>Почему следует обратиться в нашу компанию?</motion.h2>
        <motion.h3 className={styles.subtitle}  variants={titleAnimation}>Профессиональное сопровождение от начала до конца</motion.h3>
        <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box}>
                            <div className={styles.item_box_image}>
                                <img className={styles.image} src={img_6} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Юридическая надежность</p>
                        </div>
                        <p className={styles.item_text}>Гарантия законности и профессионального сопровождения на каждом этапе</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <div className={styles.item_box_image}>
                                <img className={styles.image} src={img_5} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Гарантия результатов</p>
                        </div>
                        <p className={styles.item_text}>Мы гарантируем четкое и точное выполнение обязательств перед каждым клиентом</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <div className={styles.item_box_image}>
                                <img className={styles.image_one} src={img_2} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Индивидуальный подход</p>
                        </div>
                        <p className={styles.item_text}>Мы ценим каждого клиента и обеспечиваем персональный подход и к вашим потребностям</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <div className={styles.item_box_image}>
                                <img className={styles.image} src={img_3} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Кратчайшие сроки</p>
                        </div>
                        <p className={styles.item_text}>Быстрое и качественное оказание услуг – ваше время для нас важно</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <div className={styles.item_box_image}>
                                <img className={styles.image} src={img_1} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Доступные цены</p>
                        </div>
                        <p className={styles.item_text}>Выгодные тарифы без скрытых платежей. Качество по разумной цене</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <div className={styles.item_box_image}>
                                <img className={styles.image_one} src={img_4} alt = 'логотип'/>
                            </div>
                            <p className={styles.item_title}>Богатый опыт</p>
                        </div>
                        <p className={styles.item_text}>Наши специалисты обладают обширным опытом в решение любых миграционных вопросов</p>
                    </motion.li>
                </motion.ul>
        </div>   
    </motion.section>
    )
}

export default Dignities